import { gql } from '@apollo/client';

import { fragments as imageFragments } from '../../../components/Image';
import type { ImageDataProps } from '../../../components/Image/types';
import { fragments as videoFragments } from '../../../components/Video';
import type { VideoDataProps } from '../../../components/Video/types';
import type { ContentfulSysProps, ContentfulTypedSysProps } from '../../../types/contentful';
import type { Items } from '../../../types/Items';
import { contentfulSysIdFragment } from '../../../utils/contentful/contentfulQuery';

export interface SnapHomePageCarouselCardItemProps extends ContentfulSysProps {
  body?: string;
  media: VideoDataProps | ImageDataProps;
  url?: string;
  logo?: ImageDataProps;
}

export interface SnapHomePageV2Props {
  snapHomePageV2: ContentfulTypedSysProps<'SnapHomePageV2'> & {
    title?: string;
    carouselTitle?: string;
    carouselCardsCollection?: Items<SnapHomePageCarouselCardItemProps>;
  };
}

export const snapHomePageV2Query = gql`
  query SnapHomePageV2Query($id: String!, $preview: Boolean!, $locale: String!) {
    snapHomePageV2(id: $id, preview: $preview, locale: $locale) {
      ...ContentfulSysId
      title
      carouselTitle
      carouselCardsCollection {
        items {
          ...ContentfulSysId
          body
          media {
            __typename
            ... on Video {
              ...VideoAll
            }
            ... on Image {
              ...ImageAll
            }
          }
          url
          logo {
            __typename
            ... on Image {
              ...ImageAll
            }
          }
        }
      }
    }
  }
  ${contentfulSysIdFragment}
  ${imageFragments.all}
  ${videoFragments.all}
`;
